import Link from "next/link";
import Image from "next/image";
import { unstable_ViewTransition as ViewTransition } from "react";
import { format } from "date-fns";

export default function Component({posts,itemOffset=0,itemsPerPage=10}) {
  
  

  return (
    <div className="news-list">
      {posts.slice(itemOffset, itemOffset + itemsPerPage).map((post) => (
        <div className="news-list-item" key={post.id}>
          <Link className="news-list-item-link scaleHover" href={post.pdf?post.pdf.url:`/news/article/${post.id}`} target={post.pdf?"_blank":"_self"}>
            <div className="inner">
              <div className="news-list-item-header">
                <h3 className="title line-clamp-3 ">{post.title} {post.pdf?`${post.pdf.fileSize/Math.pow(1024, 2)}`.slice(0,3)+"MB":""}{post.pdf&&<span className="icon-outerlink"><img src="/assets/img/common/icon/icon-outerlink.svg" alt="" /></span>}</h3>
                {post.eyecatch && (
                  <picture className="thumbnail">
                    <img src={post.eyecatch.url + "?fit=crop&w=160&h=160"} alt="" loading="lazy" />
                  </picture>
                )}
              </div>
              <div className="news-list-item-meta">
                <p className="date en medi">{format(new Date(post.date),"yyyy.M.d")}</p>
                {post.categories && (
                  <div className="categories">
                    <span className="category">
                      {post.categories.title}
                    </span>
                  </div>
                )}
              </div>
            </div>
          </Link>
        </div>
      ))}
    </div>
  );
}
